import { render, staticRenderFns } from "./Report-table.vue?vue&type=template&id=6aa21e86&"
import script from "./Report-table.vue?vue&type=script&lang=js&"
export * from "./Report-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports